<script lang="ts">
export default {
  name: 'KkColumnSummaryHead'
}
</script>
<script lang="ts" setup>
import { computed } from 'vue'
import { toNumberLocaleString } from '../../../../modules/localeString'
import type { LabelHeadItem, HeadIdKind } from '../../types'
import { KkLabelSummaryHead } from '../../../analysis'

export interface Props {
  headId: HeadIdKind,
  headItem: LabelHeadItem[] | number | string | null
  caption: string
}
const isRelatedSearchKeywordLabel = computed(() => {
  return props.headId === 'searchKeywordLabelBranded' || props.headId === 'searchKeywordLabelSelected'
})

const labelHeadItem = computed(() => {
  if (Array.isArray(props.headItem)) {
    return props.headItem
  }
  return null
})

const props = defineProps<Props>()
</script>

<template>
  <!-- キーワードラベルに関して -->
  <div v-if="isRelatedSearchKeywordLabel">
    <KkLabelSummaryHead :head-id="props.headId" :head-item="labelHeadItem" :caption="props.caption" />
  </div>
  <!-- キーワードラベル以外に関して -->
  <div v-else>
    {{ toNumberLocaleString(props.headItem) }}
    <span :class="$style.caption">{{ props.caption }}</span>
  </div>
</template>

<style lang="scss" module>
@import "../../../../../../stylesheets/biz_spa/foundation/var";

@import "../../../../../../stylesheets/biz_spa/foundation/mixin";
.caption {
  display: block;
  font-weight: normal;
  font-size: 10px;
  margin-top: 8px;
}
</style>
